module.exports = __webpack_public_path__ + "img/2019-10-30.247b3189.jpg";